const BASE36_RADIX = 36;

export const getRandomId = (prefix: string = ''): string =>
  `${prefix}_${Math.random().toString(BASE36_RADIX).substring(2)}`;
